import { useEffect, useRef, useState } from 'react'

// Native lazy loading may fetch several screens of photography ahead of time.
// Load these secondary homepage images shortly before they enter the viewport.
export function DeferredPicture({ src, mobileSrc, media = '(max-width: 560px)', ...props }) {
  const element = useRef(null)
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { setVisible(true); observer.disconnect() }
    }, { rootMargin: '200px' })
    observer.observe(element.current)
    return () => observer.disconnect()
  }, [])
  return <picture ref={element}>
    {mobileSrc && <source media={media} srcSet={visible ? mobileSrc : undefined} />}
    <img {...props} src={visible ? src : undefined} loading="lazy" decoding="async" />
  </picture>
}
